"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextReaderApp = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importStar(require("react"));
const TextReaderApp = ({ closeFullscreenApp, children, containerProps, }) => {
    const handleKeyPress = (0, react_2.useCallback)((event) => {
        console.log(event.code);
        switch (event.code) {
            case 'Escape':
            case 'KeyQ':
                closeFullscreenApp();
                break;
        }
    }, [closeFullscreenApp]);
    (0, react_2.useEffect)(() => {
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress]);
    return (react_2.default.createElement(react_1.Flex, Object.assign({ flex: 1, maxH: "100%", direction: "column", position: "relative" }, containerProps),
        react_2.default.createElement(react_1.Box, { flex: 1, p: 3, fontSize: "14px", overflowY: "scroll" }, children),
        react_2.default.createElement(react_1.Flex, { alignItems: "center", bgColor: "whiteAlpha.300" },
            react_2.default.createElement(react_1.Button, { borderRadius: 0, variant: "ghost", size: "xs", _hover: { outline: 'none', bgColor: 'blackAlpha.300' }, _active: { outline: 'none', bgColor: 'blackAlpha.500' }, _focus: { outline: 'none' }, onClick: closeFullscreenApp, height: "26px", paddingLeft: 3, paddingRight: 2 },
                react_2.default.createElement(react_1.Box, { px: "3px", py: "1px", bgColor: "whiteAlpha.700", color: "blackAlpha.800", mr: 1 }, "ESC"),
                react_2.default.createElement(react_1.Box, null, "Exit")))));
};
exports.TextReaderApp = TextReaderApp;
//# sourceMappingURL=TextReaderApp.js.map